import * as React from "react";
import { CheckOutForm } from "../components/checkoutForm/checkoutForm";
export interface CheckoutPageProps {}
export const CheckoutPage = (props: CheckoutPageProps) => {
  return <CheckOutForm />;
};
